import { MessageChannelSectionHrComponent } from '../MessageChannelSectionHrComponent/MessageChannelSectionHrComponent';

export const MessageChannelSectionHrReadComponent = () => (
  <MessageChannelSectionHrComponent>
    <span>Read by patient</span>
  </MessageChannelSectionHrComponent>
);
